export function QuotationReducer(state = null, action) {
    switch (action.type) {
      case "AddQuotation":
        return action.payload;
        case "RemoveQuotation":
            localStorage.removeItem('quotation')
        return state;
    default:
        return state;
    }
  }
  
